import z from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdSchema, ObjectIdString } from '../common.js';
import { AccountDTO } from './accountSchema.js';
import { UserDTO } from './userSchema.js';
import { ILlmPrompt } from './llmPromptSchema.js';
import { LlmResponseDTO } from './llmResponseModelSchemas.js';
import { CandidateDTO } from './atsEntities/index.js';

export const ReportEvent = z.enum([
  'userFeedback',
  'pageView',
  'analytics',
  'discoverFields',
  'sentEmail',
  'userImpersonationSessionStarted',
  'userImpersonationSessionEnded',
]);
export type ReportEvent = z.infer<typeof ReportEvent>;

export const ReportStatus = z.enum([
  'new',
  'resolved',
  'queued',
  'processing',
  'completed',
  'failed',
]);
export type ReportStatus = z.infer<typeof ReportStatus>;

// TODO: split into a base plus z.discriminatedUnion on `event` so each report type declares only its own
// refs, with discriminatorKey and one .discriminator() per type on the model, as concurrencyLockModel does
export const IReport = z.object({
  _id: ObjectIdSchema,
  event: ReportEvent,
  status: ReportStatus.default('new'),

  account: objectIdRef('Account').nullish(),
  user: objectIdRef('AuthUser').nullish(),
  recruiter: objectIdRef('Recruiter').nullish(),
  prompt: objectIdRef('LlmPrompt').nullish(),
  response: objectIdRef('LlmResponse').nullish(),
  chat: objectIdRef('LlmChat').nullish(),
  candidate: objectIdRef('Candidate').nullish(),

  comments: z.string().optional(),
  data: z.record(z.string(), z.unknown()).optional(),

  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IReport = z.infer<typeof IReport>;

export const ThumbChoice = z.enum(['up', 'down']);
export type ThumbChoice = z.infer<typeof ThumbChoice>;

export const ReportDTO = z.object({
  ...IReport.shape,
  _id: ObjectIdString,
  account: AccountDTO.or(ObjectIdString).nullish(),
  user: UserDTO.or(ObjectIdString).nullish(),
  prompt: ILlmPrompt.or(ObjectIdString).nullish(),
  response: LlmResponseDTO.or(ObjectIdString).nullish(),
  chat: ObjectIdString.nullish(),
  candidate: CandidateDTO.or(ObjectIdString).nullish(),
});
export type ReportDTO = z.infer<typeof ReportDTO>;
